@if (timeOut()) {
  <app-timeout></app-timeout>
} @else if (loading()) {
  <div class="flex justify-content-center">
    <p-progressSpinner ariaLabel="loading" class="customProgressSpinner" />
  </div>
} @else {
  <div
    class="securityTool"
    *appHasPermission="{
      permissions: [permissions.allPermissions.THIEF_PROTECTION_STATUS_READ],
    }"
  >
    <app-asset-hierarchy
      (assetClicked)="onAssetClicked($event)"
      [initialSelectedAssetId]="selectedAsset()!.assetId"
      [maxAssetLevel]="3"
    >
    </app-asset-hierarchy>

    <div class="widget gap-2 flex flex-column container alertList p-3">
      <div class="selectContainer">
        <p-selectButton [options]="resolvedOptions" [(ngModel)]="resolved" optionValue="value" allowEmpty="false">
          <ng-template #item let-item>
            {{ item.label | translate }}
          </ng-template>
        </p-selectButton>
      </div>
      <p-table
        [scrollable]="true"
        scrollHeight="flex"
        [paginator]="true"
        [rows]="paginatorOptions.DEFAULT_ROWS"
        [rowsPerPageOptions]="paginatorOptions.ROWS_PER_PAGE"
        [showCurrentPageReport]="true"
        [currentPageReportTemplate]="'common.page_report' | translate"
        [columns]="COLUMNS"
        [value]="paginatedAlerts()"
        [sortOrder]="-1"
        sortField="timestamp"
        [lazy]="true"
        [totalRecords]="totalRecords()"
        [first]="first()"
        (onLazyLoad)="onLazyLoad($event)"
        style="flex: 1; min-height: 0"
        class="fullTable tableHeaderAlignTop p-3"
      >
        <ng-template #header let-columns>
          <tr>
            @for (col of columns; track col) {
              <th
                [ngClass]="{ wide: col.field === 'alertType' }"
                [pSortableColumn]="col.field"
                style="padding: 0 12px 17px 12px"
              >
                <div class="headerContainer">
                  {{ col.header | translate }}
                  <p-sortIcon [field]="col.field" class="ml-2" />
                </div>
              </th>
            }
            <th></th>
          </tr>
        </ng-template>
        <ng-template #body let-rowData let-columns="columns">
          <tr>
            @for (col of columns; track col) {
              <td>
                @if ((col.field === "triggeredAt" || col.field === "resolvedAt") && rowData[col.field]) {
                  {{ convertTime(rowData[col.field]) }}
                } @else if (col.field === "gateSystem") {
                  <span
                    class="cursorDefault"
                    [pTooltip]="
                      gateIdentifierPipe.transform(
                        rowData.gateSystem,
                        permissions.hasPermission(permissions.allPermissions.ASSET_MASTER_DATA_CREATE)
                      )
                    "
                  >
                    {{ rowData[col.field].label }}
                  </span>
                } @else if (col.field === "severity") {
                  {{ `security_tool.table.severities.${rowData[col.field]}` | translate }}
                } @else if (col.field === "alertType") {
                  {{ `security_tool.table.alert_types.${rowData[col.field]}` | translate }}
                } @else if (col.field === "isResolved") {
                  {{ `security_tool.table.resolved_${rowData[col.field]}` | translate }}
                } @else {
                  {{ rowData[col.field] | translate }}
                }
              </td>
            }
            <td>
              @if (!rowData["isResolved"]) {
                <app-svg-icon
                  (click)="onResolveClick(rowData)"
                  iconName="reset"
                  iconColor="primary"
                  class="cursor-pointer"
                />
              }
            </td>
          </tr>
        </ng-template>
        <ng-template #emptymessage>
          <tr>
            <td [attr.colspan]="COLUMNS.length + 1">
              {{ "security_tool.table.no_alerts" | translate }}
            </td>
          </tr>
        </ng-template>
      </p-table>
    </div>
  </div>
}
